import axios from "axios";

const config = {
  headers: {
    "Content-Type": "multipart/form-data"
  }
};

function successAndReturn(response) {
  return response.data.data;
}

function errorWithReject(error) {
  return new Promise((resolve, reject) => {
    reject(error);
  });
}

class TemplatesService {
  constructor() {}

  downloadFile(uuid) {
    return axios.get(`/v1/contents/templates/${uuid}`, {
      timeout: 10000,
      responseType: "blob"
    });
  }

  createWithFile(name, description, file, isTemplate) {
    let formData = new FormData();
    const params = {
      name,
      description,
      isTemplate
    };
    const info = new Blob([JSON.stringify(params)], {
      type: "application/json"
    });

    formData.append("templateFile", file, file.name);
    formData.append("contentInfo", info);

    return axios
      .post("/v2/contents", formData, config)
      .then(successAndReturn, errorWithReject);
  }

  createContentFromTemplate(params) {
    let formData = new FormData();
    const p = {
      name: params.name,
      description: params.description,
      sourceTemplateUuid: params.sourceTemplateUuid,
      sourceTemplateVersion: params.sourceTemplateVersion,
      isTemplate: params.isTemplate
    };
    const info = new Blob([JSON.stringify(p)], {
      type: "application/json"
    });

    formData.append("contentInfo", info);

    return axios
      .post("/v2/contents", formData, config)
      .then(successAndReturn, errorWithReject);
  }

  updateWithFile(templateId, file, params) {
    let formData = new FormData();
    if (params && params.appId) {
      const data = {
        sourceTemplateUuid: templateId,
        uuid: params.appId,
        name: params.name,
        description: params.description,
        testRecord: params.record
      };
      const info = new Blob([JSON.stringify(data)], {
        type: "application/json"
      });
      formData.append("contentInfo", info);
    }

    if (file) {
      formData.append("templateFile", file, file.name);
    }

    return axios
      .put(`/v1/contents/templates/${templateId}`, formData, config)
      .then(successAndReturn, errorWithReject);
  }
}

export default new TemplatesService();
